import { render } from "./TheHero.vue?vue&type=template&id=f35990b2"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TheHero.vue?vue&type=style&index=0&id=f35990b2&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script